import Swiper from 'swiper';
import { A11y, FreeMode, Navigation, Thumbs, Autoplay } from 'swiper/modules';

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/a11y'
import 'swiper/css/thumbs'

import './SliderProductOverview.css'

export default () => {

  let thumbs;
  const swiperParamsThumbs = {
    // Install modules
    modules: [A11y, FreeMode, Navigation, Thumbs, Autoplay],
    slidesPerView: 3,
    spaceBetween: 10,
    freeMode: true,
    lazy: true,
    watchSlidesProgress: true,
    cssMode: true,
    // Responsive breakpoints
    breakpoints: {
      1024: {
        slidesPerView: 5
      },
      640: {
        slidesPerView: 4,
      },
    }
  };

  if(document.querySelector('[data-slider-thumbs]')) {
    thumbs = new Swiper('[data-slider-thumbs]', swiperParamsThumbs);
  }

  const swiperParamsPreview = {
    modules: [A11y, FreeMode, Navigation, Thumbs, Autoplay],
    slidesPerView: 1,
    lazy: true,
    autoplay: true,
    cssMode: true
  };

  const sliderPO = new Swiper('[data-slider-preview]', swiperParamsPreview);

  if(document.querySelector('[data-slider-thumbs]')) {
    sliderPO.thumbs.swiper = thumbs;
  }

}
